import { printf } from 'utils/i18n';

const config = {
    selectError: (value: string): string => printf(__(`Please select your %s`), value),
    inputError: (value: string): string => printf(__(`Please enter your %s`), value),
    inputTheError: (value: string): string => printf(__(`Please enter the %s`), value),
    inputAError: (value: string, an: boolean): string =>
        an ? printf(__(`Please enter an %s`), value) : printf(__(`Please enter a %s`), value),
    selectAddressError: (value: string, an: boolean): string =>
        an ? printf(__(`Please select an %s`), value) : printf(__(`Please select a %s`), value),
    error: __('Please Enter...'),
    citizenship: [
        { value: 0, name: __('I’m a resident of U.S.') },
        { value: 1, name: __('I’m not a resident of U.S.') }
    ],
    family_member: [
        { value: 0, name: '0' },
        { value: 1, name: '1' },
        { value: 2, name: '2' },
        { value: 3, name: '3' },
        { value: 4, name: '4' },
        { value: 5, name: '5' },
        { value: 6, name: '6' },
        { value: 7, name: '7' },
        { value: 8, name: '8' },
        { value: 9, name: '9' },
        { value: 10, name: '10' }
    ],
    Relationship: [
        __('Account Holder(Myself)'),
        __('Mother'),
        __('Father'),
        __('Spouse'),
        __('Daughter'),
        __('Son'),
        __('Sister'),
        __('Brother'),
        __('Aunt'),
        __('Niece'),
        __('Nephew'),
        __('Cousin'),
        __('Grandmother'),
        __('Grandfather'),
        __('Granddaughter'),
        __('Grandson'),
        __('Stepsister'),
        __('Stepbrother'),
        __('Stepmother'),
        __('Stepfather'),
        __('Stepdaughter'),
        __('Stepson'),
        __('Sister-in-law'),
        __('Brother-in-law'),
        __('Mother-in-law'),
        __('Father-in-law'),
        __('Daughter-in-law'),
        __('Son-in-law')
    ]
};

export default config;
